import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/components/PageHeader";
import { OwnerForm } from "@/components/OwnerForm";
import { useT } from "@/context/LanguageContext";

export default function OwnerFormPage() {
  const t = useT().ownerForm;
  return (
    <>
      <Seo title="Confiez-nous votre bien" description="Vous possédez un appartement, une villa ou un hébergement destiné à la location saisonnière ? Parlons de son potentiel." path="/confier-mon-bien" />
      <PageHeader overline={t.overline} title={t.title} intro={t.intro} />
      <section className="py-20 sm:py-28 max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal><OwnerForm /></Reveal>
      </section>
    </>
  );
}
